export default function() {
  if (process.env.VUE_APP_TOUCHPOINT_DATA_SET === "wall") {
    return data[process.env.VUE_APP_TOUCHPOINT_DATA_SET];
  } else {
    if (/Edge/.test(navigator.userAgent)) {
      return data[process.env.VUE_APP_TOUCHPOINT_DATA_SET].edgeCase;
    } else {
      return data[process.env.VUE_APP_TOUCHPOINT_DATA_SET].default;
    }
  }
}
let data = {
  wall: {
    zoneOne: "vmware-power-v3.json",
    zoneTwo: "vmware-energy-efficiency.json",
    zoneThree: "vmware-emergencyresponse.json",
    zoneFour: "vmware-multitransit.json",
    zoneFive: "vmware-traffic.json",
    zoneSix: "vmware-improve-supply-chain.json",
    zoneSeven: "vmware-proactive-maintenance.json",
    zoneEight: "vmware-healthcare1.json",
    zoneNine: "vmware-healthcare2.json",
    zoneTen: "vmware-customer-loyalty.json",
    zoneEleven: "dell-maritime.json",
    zoneTwelve: "dell-surveillance.json"
  },
  browser: {
    default: {
      zoneOne: "vmware-power-v3-b.json",
      zoneTwo: "vmware-energy-efficiency-b.json",
      zoneThree: "vmware-emergencyresponse-b.json",
      zoneFour: "vmware-multitransit-b-4.json",
      zoneFive: "vmware-traffic-b.json",
      zoneSix: "vmware-improve-supply-chain-b1.json",
      zoneSeven: "vmware-proactive-maintenance-b.json",
      zoneEight: "vmware-healthcare1-b.json",
      zoneNine: "vmware-healthcare2-b.json",
      zoneTen: "vmware-customer-loyalty-b.json",
      zoneEleven: "dell-maritime-b.json",
      zoneTwelve: "dell-surveillance-b.json"
    },
    edgeCase: {
      zoneOne: "vmware-power-v3-b-edge.json",
      zoneTwo: "vmware-energy-efficiency-b-edge.json",
      zoneThree: "vmware-emergencyresponse-b-edge.json",
      zoneFour: "vmware-multitransit-b-4-edge.json",
      zoneFive: "vmware-traffic-b.json",
      zoneSix: "vmware-improve-supply-chain-b1-edge.json",
      zoneSeven: "vmware-proactive-maintenance-b.json",
      zoneEight: "vmware-healthcare1-b.json",
      zoneNine: "vmware-healthcare2-b-edge.json",
      zoneTen: "vmware-customer-loyalty-b-edge.json",
      zoneEleven: "dell-maritime-b-edge.json",
      zoneTwelve: "dell-surveillance-b-edge.json"
    }
  }
};
